import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';

import VScroll from '../../../../gd-components/scrolling/custom-v-scroll/v-scroll.tsx';
import Button from 'gd-comp-button';
import FileItem from './file-item.jsx';
import AddFolder from './add-folder.jsx';
import PathView from './path-view.jsx';

const {} = require('formdata-polyfill');
import _ from 'lodash';
import Classes from 'classnames';

class ModalGoogleDriveViewAttach extends React.Component {
    static propTypes = {
        rootFolder: PropTypes.string,
        data: PropTypes.array,
        attachments: PropTypes.array,

        onAttachFiles: PropTypes.func,
        onFolderClick: PropTypes.func,
        onAddFolder: PropTypes.func,
        onUpload: PropTypes.func,
        onRefresh: PropTypes.func,
    };

    static defaultProps = {
        rootFolder: "Google drive",
        data: [],
        attachments: []
    };

    state = {
        data: this.props.data,
        parents: [{
            id: null,
            name: this.props.rootFolder
        }],
        checkedFiles: this.props.attachments,
        addFolderState: false
    };

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({data: nextProps.data});
    }

    onAttachClick = () => {
        const { onAttachFiles } = this.props;
        const { checkedFiles } = this.state
        if (onAttachFiles && checkedFiles.length > 0){
            onAttachFiles(checkedFiles);
            gd.modal.hide();
        }
    };

    onFolderClick = (folderId, folderName) => {
        const { onFolderClick } = this.props;
        const { parents } = this.state;

        const newParents = parents.slice();
        newParents.push({
            id: folderId,
            name: folderName
        });

        this.setState({
            parents: newParents,
            data: null,
            checkedFiles: []
        }, ()=>{if (onFolderClick) onFolderClick(folderId)});
    };

    onParentFolderClick = () => {
        const { onFolderClick } = this.props;
        const { parents } = this.state;

        const newParents = parents.slice();
        newParents.pop();
        const parentFolderId = newParents[newParents.length-1].id;
        this.setState({
            parents: newParents,
            data: null,
            checkedFiles: []
        }, ()=>{if (onFolderClick) onFolderClick(parentFolderId)});
    };

    onParentClick = (id) => {
        const { onFolderClick } = this.props;
        const { parents } = this.state;

        const newParents = parents.slice(0,_.findIndex(parents, p=>p.id === id) + 1);
        this.setState({
            parents: newParents,
            data: null,
            checkedFiles: []
        }, ()=>{if (onFolderClick) onFolderClick(id)});
    };

    onNewFolder = () => {
        this.setState({addFolderState: true});
    };

    onCancelAddFolder = () => {
        this.setState({addFolderState: false});
    };

    onAddFolder = (result) => {
        const { onAddFolder } = this.props;
        this.setState({addFolderState: false},
            ()=>{if (onAddFolder) onAddFolder(result.title)});
    };

    onCheckFileItem = (file) => {
        const { checkedFiles } = this.state;
        let newCheckedFiles = checkedFiles.slice();
        if (_.find(newCheckedFiles, f=>f.fileId === file.fileId)) _.remove(newCheckedFiles, f=>f.fileId === file.fileId);
        else newCheckedFiles.push(file);

        this.setState({
            checkedFiles: newCheckedFiles
        });
    };

    onDeleteClick = (id) => {
        const { onDeleteClick } = this.props;
        if (onDeleteClick) onDeleteClick(id);
    };

    onUpload = () => {
        this.refs.file_upload.click();
    };

    handleFileUpload = (event) => {
        const { onUpload } = this.props;

        const file = event.target.files[0];
        const formData = new FormData();
        formData.append('uploaded', file, file.name);

        if (onUpload) onUpload(formData);
    };

    onRefresh = () => {
        const { onRefresh } = this.props;
        if (onRefresh) onRefresh();
    };

    renderMain = () => {
        const { data, parents, checkedFiles, addFolderState } = this.state;

        const listItems = [];
        if (this.state.data) {
            const sortedData = _.chain(data)
                .orderBy([i=>i.mimeType.indexOf("folder") !== -1 ? 0 : 1, 'name'],['asc', 'asc'])
                .value();

            sortedData.map((d,key)=>{
                listItems.push(<FileItem key={d.id ? d.id : "temp_"+key}
                                         id={d.id}
                                         mimeType={d.mimeType}
                                         iconLink={d.iconLink}
                                         name={d.name}
                                         size={d.size}
                                         modifiedTime={d.modifiedTime}
                                         webViewLink={d.webViewLink}
                                         thumbnailLink={d.thumbnailLink}
                                         checked={!!_.find(checkedFiles, f=>f.fileId === d.id)}
                                         onFolderClick={this.onFolderClick}
                                         onCheckClick={this.onCheckFileItem}
                                         onDeleteClick={this.onDeleteClick}/>)
            })
        }

        let main;
        if (addFolderState) {
            main = <AddFolder onAddFolder={this.onAddFolder} onCancel={this.onCancelAddFolder}/>;
        } else {
            main = (
                <div className="main-body">
                    <VScroll className="main-list">
                        {parents.length > 1 &&
                        <div className="up-button" onClick={this.onParentFolderClick}>
                            <div className="icon i5-long-arrow-up"> </div>
                            Parent folder
                        </div>}

                        {listItems}
                    </VScroll>
                </div>
            );
        }
        return main;
    };

    render() {
        const { parents, checkedFiles, addFolderState } = this.state;

        return (
            <div className="main-content">
                <div className="main-title"><img className="gdrive-icon" src="/app/web/skin/common/svg/g-drive.svg"/>Google Drive. Choose files</div>
                <div className="main-header">
                    <PathView parents={parents} onParentClick={this.onParentClick}/>

                    <div className="actions">

                        <form ref="frm" className="hidden-input" encType="multipart/form-data">
                            <input ref="file_upload" name="uploaded" type="file" onChange={this.handleFileUpload}/>
                        </form>

                        <div className="action-button upload-button" onClick={this.onUpload}><div className="icon ii5-cloud-upload"> </div>Upload</div>
                        <div className="action-button new-button" onClick={this.onNewFolder}><div className="icon i5-plus"> </div>New folder</div>
                        <div className="action-button refresh-button" onClick={this.onRefresh}><div className="icon i5-refresh"> </div>Refresh</div>
                    </div>
                </div>

                {this.renderMain()}

                <div className="main-actions">
                    {!addFolderState && <Button className={Classes("action-button", {disabled: checkedFiles.length === 0})}
                                                onClick={this.onAttachClick}
                                                label="Attach selected files"
                                                type="primary"/>}
                </div>
            </div>
        );
    }
}

module.exports = ModalGoogleDriveViewAttach;
